package com.vamvisions.main.portfolio.data.repository

import com.vamvisions.main.core.domain.DataError
import com.vamvisions.main.core.domain.Result
import com.vamvisions.main.core.domain.map
import com.vamvisions.main.core.domain.preferences.Language
import com.vamvisions.main.portfolio.data.mapper.toExperience
import com.vamvisions.main.portfolio.data.remote.PortfolioApi
import com.vamvisions.main.portfolio.domain.model.Experience
import com.vamvisions.main.portfolio.domain.repository.ExperienceRepository

/** Fetches the experience entries from the server on every call; nothing is cached. */
class RemoteExperienceRepository(private val api: PortfolioApi) : ExperienceRepository {

    override suspend fun get(language: Language): Result<List<Experience>, DataError.Network> =
        api.getExperiences(language).map { response -> response.items.map { it.toExperience() } }
}
